import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { ChatPinInvite } from '../interfaces/chat-pin-invite.interface';
import { BoldItem } from '../interfaces/workitem-bold.interface';
import { WorkItemBold } from './workitem-bold';
import { PinType } from '../constants/pin-types';

export class WorkItemChatPinInvite extends WorkItemBold implements ChatPinInvite, BoldItem {
  public readonly type: string = WorkItemTypes.CHAT_PIN_INVITE;
  public expiringAt: number;
  public pinCode: string;
  public pinType: PinType;
  public title: string = '';
  public widgetTitle: string = '';
  public ItemID: string;

  private _expired: boolean;

  constructor(workItem) {
    super(workItem);

    if (!workItem) {
      throw new Error('workItem must be specified');
    }

    this._id = workItem._id || workItem.pinvitationId;
    this._expired = workItem.expired;
    this.expiringAt = workItem.expiringAt;

    if (!this.expiringAt) {
      const currentDateInMilliseconds = new Date().getTime();

      this.expiringAt = currentDateInMilliseconds + (workItem.timeoutInSec * 1000);
    }

    this.pinCode = workItem.pinCode;
    this.pinType = workItem.pinType;
    this.setPinInviteTitleByType();
    this.setWidgetTitleByType();

    this._isCollapsible = true;
    this.isClosable = true;

    this._avatarThemeId = 'invite';
  }

  isExpired() {
    return this._expired || (new Date().getTime() > this.expiringAt);
  }

  setPinInviteTitleByType(): void {
    switch (this.pinType) {
      case PinType.RC:
        this.title = 'bcWorkitemChatList.startRemoteAccessWithPin';
        break;

      case PinType.COBROWSE: {
        this.title = 'bcWorkitemChatList.startCoBrowseWithPin';
        break;
      }
      default:
        break;
    }
  }

  setWidgetTitleByType(): void {
    switch (this.pinType) {
      case PinType.RC:
        this.widgetTitle = 'bcWorkitemChatList.pinInviteWorkItemTitle';
        break;

      case PinType.COBROWSE: {
        this.widgetTitle = 'bcWorkitemChatList.newCoBrowseTooltip';
        break;
      }
      default:
        break;
    }
  }
}
